import type { SVGProps } from "react";
const SvgSadFace = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60 60" {...props}>
    <path
      fill="#96979A"
      d="M30.5 13.75A16.25 16.25 0 1 0 46.75 30 16.267 16.267 0 0 0 30.5 13.75m0 30A13.75 13.75 0 1 1 44.25 30 13.766 13.766 0 0 1 30.5 43.75M23 26.875a1.875 1.875 0 1 1 3.75 0 1.875 1.875 0 0 1-3.75 0m15 0a1.875 1.875 0 1 1-3.75 0 1.875 1.875 0 0 1 3.75 0m-.169 10a1.252 1.252 0 0 1-.904 1.911 1.25 1.25 0 0 1-1.258-.661C34.502 36.108 32.667 35 30.5 35s-4.002 1.11-5.169 3.125a1.25 1.25 0 1 1-2.162-1.25c1.608-2.78 4.28-4.375 7.331-4.375s5.723 1.594 7.331 4.375"
    />
  </svg>
);
export default SvgSadFace;
